"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoCompletePanel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ObjectUtils = _interopRequireDefault(require("../utils/ObjectUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AutoCompletePanel = /*#__PURE__*/function (_Component) {
  _inherits(AutoCompletePanel, _Component);

  var _super = _createSuper(AutoCompletePanel);

  function AutoCompletePanel() {
    _classCallCheck(this, AutoCompletePanel);

    return _super.apply(this, arguments);
  }

  _createClass(AutoCompletePanel, [{
    key: "renderElement",
    value: function renderElement() {
      var _this = this;

      var items;

      if (this.props.suggestions) {
        items = this.props.suggestions.map(function (suggestion, index) {
          var itemContent = _this.props.itemTemplate ? _this.props.itemTemplate(suggestion) : _this.props.field ? _ObjectUtils.default.resolveFieldData(suggestion, _this.props.field) : suggestion;
          return /*#__PURE__*/_react.default.createElement("li", {
            key: index + '_item',
            role: "option",
            "aria-selected": _this.props.ariaSelected === suggestion,
            className: `p-autocomplete-list-item ${_this.props.ariaSelected === suggestion ? 'p-highlight' : ''}`,
            onClick: function onClick(e) {
              return _this.props.onItemClick(e, suggestion);
            }
          }, itemContent);
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(el) {
          return _this.element = el;
        },
        className: "p-autocomplete-panel p-input-overlay",
        style: {
          maxHeight: this.props.scrollHeight
        }
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "p-autocomplete-items p-autocomplete-list p-component p-reset",
        role: "listbox",
        id: this.props.listId
      }, items));
    }
  }, {
    key: "render",
    value: function render() {
      var element = this.renderElement();

      if (this.props.appendTo) {
        return _reactDom.default.createPortal(element, this.props.appendTo);
      } else {
        return element;
      }
    }
  }]);

  return AutoCompletePanel;
}(_react.Component);

exports.AutoCompletePanel = AutoCompletePanel;

_defineProperty(AutoCompletePanel, "defaultProps", {
  suggestions: null,
  field: null,
  appendTo: null,
  itemTemplate: null,
  onItemClick: null,
  scrollHeight: '200px',
  listId: null,
  ariaSelected: null
});

_defineProperty(AutoCompletePanel, "propTypes", {
  suggestions: _propTypes.default.array,
  field: _propTypes.default.string,
  appendTo: _propTypes.default.any,
  itemTemplate: _propTypes.default.func,
  onItemClick: _propTypes.default.func,
  scrollHeight: _propTypes.default.string,
  listId: _propTypes.default.any,
  ariaSelected: _propTypes.default.any
});